export default "__VITE_ASSET__BWdFVYlg__"